import React, { useEffect, useState } from "react";
import Layout from "./layout/Layout";
import { getSMSBaseDates, getSMSTemplates, sendSMS } from "services/sms";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../node_modules/react-toastify/dist/ReactToastify.css";

toast.configure({
    position: "top-right", // Position of toast messages
    autoClose: 5000, // Auto close time in milliseconds
    hideProgressBar: false, // Whether to show progress bar
    closeOnClick: true, // Close toast on click
    pauseOnHover: true, // Pause timer when hovering over toast
    draggable: true, // Make toast draggable
    draggablePercent: 60 // Percentage of toast width draggable
});

const SendSMS = () => {
    const [dates, setDates] = useState([]);
    const [templates, setTemplates] = useState();
    const [selectedDates, setSelectedDates] = useState([]);
    const [selectedTemplate, setSelectedTemplate] = useState("");

    const fetchTemplates = async () => {
        const templates = await getSMSTemplates();
        setTemplates(templates.data);
    };
    const fetchDates = async () => {
        // try{
        const dates = await getSMSBaseDates();
        setDates(dates.data);
        // }catch(e){
        //   console.error("error fetching dates")
        // }
    };
    const handleCheckBoxChange = (date) => {
        setSelectedDates((prevDates) =>
            prevDates.includes(date) ? prevDates.filter((d) => d !== date) : [...prevDates, date]
        );
    };

    useEffect(() => {
        fetchTemplates();
        fetchDates();
    }, [getSMSTemplates, getSMSBaseDates]);

    const handleSendSMS = async (e) => {
        e.preventDefault();
        console.log(selectedDates, selectedTemplate);

        if (!selectedTemplate || !selectedDates.length) {
            return;
        }

        try {
            const response = await sendSMS({
                baseDates: selectedDates,
                templateId: selectedTemplate
            });
            setSelectedDates([]);
            setSelectedTemplate("");
            if (response.status === 200) {
                toast.success("SMS sent Successfully");
            } else {
                toast.error("Error sending SMS please try again");
            }
        } catch (error) {
            console.log("Inside failure", error);
            toast.error("Error uploading file");
        }
    };
    return (
        <Layout>
            <div className="rows" style={{ paddingTop: "50px" }}>
                <div className="containers table-responsive" align="center">
                    <form onSubmit={handleSendSMS}>
                        <table
                            id="example1"
                            className="display nowrap ns z-depth-1 table table-striped table-bordered row-border order-column table-hover"
                            style={{ width: "50%" }}
                        >
                            <thead>
                                <tr>
                                    <th
                                        colSpan="2"
                                        className="black-text text-darken-2"
                                        style={{
                                            fontFamily: "Cambria, Georgia, serif",
                                            fontSize: "16px",
                                            fontStyle: "normal",
                                            fontVariant: "normal",
                                            fontWeight: 500,
                                            textAlign: "center",
                                            backgroundColor: "#3f5c9a"
                                        }}
                                    >
                                        Send SMS
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td
                                        className="ns"
                                        style={{
                                            textAlign: "left"
                                        }}
                                    >
                                        Dates
                                    </td>
                                    <td
                                        className="ns"
                                        style={{
                                            textAlign: "left",
                                            display: "flex",
                                            gap: "10px",
                                            flexWrap: "wrap"
                                        }}
                                    >
                                        {dates &&
                                            dates.map((date, index) => (
                                                <div className="" key={index}>
                                                    <input
                                                        id={`checkbox-${date.date}-${index}`}
                                                        type="checkbox"
                                                        checked={selectedDates.includes(date.date)}
                                                        className=""
                                                        onChange={() =>
                                                            handleCheckBoxChange(date.date)
                                                        }
                                                    />
                                                    <label
                                                        htmlFor={`checkbox-${date.date}-${index}`}
                                                    >
                                                        {date.date} ({date.count})
                                                    </label>
                                                </div>
                                            ))}
                                    </td>
                                </tr>
                                <tr>
                                    <td
                                        className="ns"
                                        style={{
                                            textAlign: "left"
                                        }}
                                    >
                                        Select Template
                                    </td>
                                    <td
                                        className="ns"
                                        style={{
                                            textAlign: "left"
                                        }}
                                    >
                                        <select
                                            className="form-control"
                                            name="subPlan"
                                            onChange={(e) => setSelectedTemplate(e.target.value)}
                                        >
                                            <option
                                                value={0}
                                                style={{ maxWidth: "300px", overflow: "auto" }}
                                                selected
                                            >
                                                Select a template
                                            </option>
                                            {templates &&
                                                templates
                                                    .filter(
                                                        (template) =>
                                                            template.portuguese &&
                                                            template.portuguese.trim() !== ""
                                                    )
                                                    .map((template, index) => (
                                                        <option
                                                            value={template.id}
                                                            key={template.id}
                                                            style={{
                                                                maxWidth: "300px",
                                                                overflow: "auto"
                                                            }}
                                                        >
                                                            {template.portuguese.slice(0, 100)}
                                                        </option>
                                                    ))}
                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                    <td
                                        colSpan="2"
                                        className="black-text text-darken-2"
                                        style={{
                                            fontFamily: "Cambria, Georgia, serif",
                                            fontSize: "16px",
                                            fontStyle: "normal",
                                            fontVariant: "normal",
                                            fontWeight: 500,
                                            textAlign: "center"
                                        }}
                                    >
                                        <button
                                            name="configure"
                                            type="submit"
                                            className="btn btn-primary waves-light"
                                        >
                                            Send SMS
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </form>
                </div>
            </div>
        </Layout>
    );
};

export default SendSMS;
